export default __webpack_public_path__ + "static/media/cloudez_footer.db2eeeaf.svg";